import React from 'react';
import { Button } from './button';
import classNames from 'classnames';
/**
* @param {Object} props
* @param {Object} props.children
* @param {string} props.className
* @param {boolean} props.disabled
* @param {string} props.id
* @param {boolean} props.isLoading
* @param {boolean} props.isSelected
* @param {Function} props.onClick
* @param {string} props.size - "sm", "md", "lg"
* @param {string} props.type
* @returns {Object}
*/
export function ButtonPill(props) {
	const { className, children, disabled, id, isLoading, isSelected, onClick, size, type, } = props;
	const buttonClassName = classNames(
		"pill",
		className,
	)
	return (
		<Button
			className={buttonClassName}
			disabled={disabled}
			id={id}
			isLoading={isLoading}
			isSelected={isSelected}
			onClick={onClick}
			size={size}
			type={type}
		>	
			{children}
		</Button>
	);
};